<div class="tool">
  <div class="user-info">
    <div class="avatar-wrap" matBadgeColor="warn" matBadgeSize="small">
      <button class="avatar-trigger" type="button" (click)="onOpenAvatarDialog()" [attr.aria-label]="'USER.TOOL.SELECT_AVATAR' | translate" [matTooltip]="'USER.TOOL.SELECT_AVATAR' | translate" matTooltipPosition="above">
        <p-avatar
          [image]="logedUser?.avatarUrl || '../../../assets/icons/icon-sbest-512x512.png'"
          size="xlarge"
          shape="circle">
        </p-avatar>
        <span class="avatar-edit-indicator">
          <mat-icon>photo_camera</mat-icon>
        </span>
      </button>
    </div>

    <div class="user-data">
      <button class="profile-name" type="button" (click)="onOpenProfile()" [attr.aria-label]="'USER.TOOL.PROFILE' | translate" [matTooltip]="'USER.TOOL.PROFILE' | translate" matTooltipPosition="above">
        <h2>{{ logedUser?.name || 'N/A' }}</h2>
        <mat-icon aria-hidden="true">edit</mat-icon>
      </button>
      <p class="secondary-data">{{ logedUser?.email || 'N/A' }}</p>
      <p class="secondary-data department-data">{{ logedUser?._dpto || 'N/A' }}</p>
      @if (logedUser?.profileTitle) {
        <p class="secondary-data profile-meta">{{ logedUser?.profileTitle }}</p>
      }
    </div>
  </div>

  <div class="actions">
    <button class="action-btn" mat-icon-button color="primary" [matBadge]="unreadMessages" matBadgeColor="warn" [matBadgeHidden]="unreadMessages === 0" (click)="onOpenChat()" [attr.aria-label]="'USER.TOOL.MESSAGES' | translate" [matTooltip]="'USER.TOOL.MESSAGES' | translate" matTooltipPosition="above">
      <mat-icon>message</mat-icon>
    </button>
    <button class="action-btn" mat-icon-button color="primary" [matBadge]="pendingAgenda" matBadgeColor="accent" [matBadgeHidden]="pendingAgenda === 0" (click)="onOpenAgenda()" [attr.aria-label]="'USER.TOOL.AGENDA' | translate" [matTooltip]="'USER.TOOL.AGENDA' | translate" matTooltipPosition="above">
      <mat-icon>calendar_month</mat-icon>
    </button>
    <button class="action-btn action-btn--tasks" mat-icon-button color="primary" [matBadge]="pendingTasksBadge" matBadgeColor="warn" [matBadgeHidden]="pendingTasks === 0" (click)="onOpenTasks()" [attr.aria-label]="'USER.TOOL.PENDING_TASKS' | translate" [matTooltip]="'USER.TOOL.PENDING_TASKS' | translate" matTooltipPosition="above">
      <mat-icon>add_task</mat-icon>
    </button>
    <button class="action-btn" mat-icon-button color="primary" (click)="onOpenNotes()" [attr.aria-label]="'USER.TOOL.QUICK_NOTES' | translate" [matTooltip]="'USER.TOOL.QUICK_NOTES' | translate" matTooltipPosition="above">
      <mat-icon>sticky_note_2</mat-icon>
    </button>
    <button class="action-btn" mat-icon-button color="primary" [matBadge]="unreadNotifications()" matBadgeColor="warn" [matBadgeHidden]="unreadNotifications() === 0" (click)="onOpenNotificationInbox()" [attr.aria-label]="'USER.TOOL.NOTIFICATION_INBOX' | translate" [matTooltip]="'USER.TOOL.NOTIFICATION_INBOX' | translate" matTooltipPosition="above">
      <mat-icon>notifications</mat-icon>
    </button>
    <button class="action-btn" mat-icon-button color="primary" [matBadge]="unreadSpecialOrderNotifications()" matBadgeColor="accent" [matBadgeHidden]="unreadSpecialOrderNotifications() === 0" (click)="onOpenSpecialOrderNotifications()" [attr.aria-label]="'USER.TOOL.SPECIAL_ORDER_NOTIFICATIONS' | translate" [matTooltip]="'USER.TOOL.SPECIAL_ORDER_NOTIFICATIONS' | translate" matTooltipPosition="above">
      <mat-icon>event_note</mat-icon>
    </button>
    @if (canScanQr) {
      <button class="action-btn" mat-icon-button color="primary" (click)="onOpenQrScanner()" [disabled]="qrLoading" [attr.aria-busy]="qrLoading" [attr.aria-label]="'USER.TOOL.QR_SCAN' | translate" [matTooltip]="'USER.TOOL.QR_SCAN' | translate" matTooltipPosition="above">
        <mat-icon>{{ qrLoading ? 'hourglass_top' : 'qr_code_scanner' }}</mat-icon>
      </button>
      @if (qrLoadError) {
        <span class="lazy-load-error" role="alert">No se pudo cargar el escáner QR. Inténtalo de nuevo.</span>
      }
    }
    <button class="action-btn" mat-icon-button color="primary" (click)="themeService.toggleTheme()" [attr.aria-label]="'USER.TOOL.CHANGE_THEME' | translate" [matTooltip]="'USER.TOOL.CHANGE_THEME' | translate" matTooltipPosition="above">
      <mat-icon>{{ themeService.isDarkMode() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
    <button class="action-btn" mat-icon-button color="primary" (click)="onLogout()" [attr.aria-label]="'USER.TOOL.LOGOUT' | translate" [matTooltip]="'USER.TOOL.LOGOUT' | translate" matTooltipPosition="above">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>
</div>
